import { Button, Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

export default function UploadButton(props: any) {
    const { machineScan, machineActive, disableUploadButton, uploadButtonText } = props
    const [uploadButtonClicked, setUploadButtonClicked] = useState<boolean>(false);
    const [dots, setDots] = useState<string>("");
    const { t } = useTranslation();

    const styles = {
        CircularProgress: {
            mr: 1,
            color: "#FFFFFF"
        },
        dotsContainer: {
            display: 'inline-block',
            width: '24px',  // Fixed width for the dots
            textAlign: 'left'
        }
    }

    useEffect(() => {
        if (uploadButtonClicked && !machineActive) {
            setUploadButtonClicked(false)
        }
    }, [uploadButtonClicked, machineActive, setUploadButtonClicked])

    // Animate the dots when the button is clicked and the machine is active
    useEffect(() => {
        let dotsInterval: NodeJS.Timeout;

        if (uploadButtonClicked && machineActive) {
            dotsInterval = setInterval(() => {
                setDots(prevDots => {
                    if (prevDots.length >= 3) return "";
                    return prevDots + ".";
                });
            }, 500); // Change dot every 500ms
        }

        return () => {
            if (dotsInterval) clearInterval(dotsInterval);
        };
    }, [uploadButtonClicked, machineActive]);    // Translate the upload button text
    const getUploadButtonText = () => {
        if (uploadButtonText === "Upload") return t('control.inputs.buttons.upload');
        if (uploadButtonText === "Uploaded") return t('control.inputs.buttons.uploaded');
        return uploadButtonText;
    };

    if (!machineActive) {
        return (
            <Grid item xl={5.25} xs={5.25} pt={2} pb={3}>
                <Button className="Upload-Export-Blue" disabled={disableUploadButton} fullWidth onClick={() => {
                    machineScan("upload")
                    setUploadButtonClicked(true)
                }}
                >{getUploadButtonText()}</Button>
            </Grid>
        )
    } else {
        return (
            <Grid item xl={5.25} xs={5.25} pt={2} pb={3}>
                <Button className="Upload-Export-Blue" disabled fullWidth onClick={() => { machineScan("upload") }}>
                    {uploadButtonClicked ? 
                        <>
                            {t('control.inputs.buttons.uploading')}<Box component="span" sx={styles.dotsContainer}>{dots}</Box>
                        </>
                        :
                        <CircularProgress size={20} sx={styles.CircularProgress} />
                }
                </Button>
            </Grid>
        )
    }
}